import { OnInit } from '@angular/core';
var TranslatorQuizComponent = /** @class */ (function () {
    function TranslatorQuizComponent() {
    }
    TranslatorQuizComponent.prototype.ngOnInit = function () {
    };
    return TranslatorQuizComponent;
}());
export { TranslatorQuizComponent };
